module.exports = __webpack_public_path__ + "static/43-future-of-work-remote-workers-are-happier-loyal-and-more-productive-c63b87e7e0cd38d3a886dc503ac72dfb.jpg";